var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeticionesPendientes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 57,
    viewBox: "0 0 63 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2728 28.5C37.1428 28.5 31.3561 33.82 31.3561 40.375C31.3561 46.93 37.1428 52.25 44.2728 52.25C51.4028 52.25 57.1895 46.93 57.1895 40.375C57.1895 33.82 51.4028 28.5 44.2728 28.5ZM48.5353 45.9562L42.9811 40.85V33.25H45.5645V39.8763L50.3436 44.27L48.5353 45.9562ZM46.8561 7.125H38.6411C37.5561 4.37 34.7145 2.375 31.3561 2.375C27.9978 2.375 25.1561 4.37 24.0711 7.125H15.8561C13.0145 7.125 10.6895 9.2625 10.6895 11.875V47.5C10.6895 50.1125 13.0145 52.25 15.8561 52.25H31.6403C30.1119 50.8862 28.8686 49.2762 27.972 47.5H15.8561V11.875H21.0228V19H41.6895V11.875H46.8561V23.94C48.6903 24.1775 50.4211 24.6763 52.0228 25.365V11.875C52.0228 9.2625 49.6978 7.125 46.8561 7.125ZM31.3561 11.875C29.9353 11.875 28.7728 10.8062 28.7728 9.5C28.7728 8.19375 29.9353 7.125 31.3561 7.125C32.777 7.125 33.9395 8.19375 33.9395 9.5C33.9395 10.8062 32.777 11.875 31.3561 11.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeticionesPendientes);
export default __webpack_public_path__ + "static/media/peticionesPendientes.f9272eec1b4b90e5f23ccec8b7cb163d.svg";
export { ForwardRef as ReactComponent };